<template>
	<div>
		<StandardModal
			open
			large
			:title="$t('admin_common_results')"
			:confirmText="$t('common_button_done')"
			hideCancel
			@confirm="$emit('confirm', $event)"
			@cancel="$emit('cancel', $event)"
			class="bulk-error-modal"
			ref="errorModal"
		>
			<div class="results-section">
				<div v-if="successCount > 0" class="results-banner success">
					<slot name="success" :count="successCount">
						<CircleCheckIcon type="regular" />
						{{
							$t(
								'admin_common_results_successes.variable',
								{
									Count: successCount,
								},
								successCount
							)
						}}
					</slot>
				</div>
				<div v-if="errors.length > 0" class="results-banner error">
					<slot name="error" :count="errorCount">
						<CircleExclamationIcon type="regular" />
						{{
							$t(
								'admin_common_results_failures.variable',
								{
									Count: errorCount,
								},
								errorCount
							)
						}}
					</slot>
				</div>
			</div>
			<div class="results-section" v-for="error in errors" :key="error.code">
				<div class="error-item" @click="showDetailsForError = error">
					<slot name="error-item" :data="error">
						<div class="error-item-left">
							<slot name="error-item-left" :data="error" />
						</div>
						<div class="error-item-right">
							<slot name="error-item-right" :data="error">
								<CircleExclamationIcon type="regular" />
								{{ $t('admin_common_results_failure_view') }}
							</slot>
						</div>
					</slot>
				</div>
			</div>
		</StandardModal>
		<StandardModal
			v-if="showDetailsForError"
			open
			small
			:title="$t('common_error')"
			:confirmText="$t('common_button_done')"
			:confirmProps="{ danger: true }"
			hideCancel
			@confirm="showDetailsForError = null"
			@cancel="showDetailsForError = null"
			class="error-details-modal"
		>
			<CircleExclamationIcon type="regular" halo />
			<div
				class="error-details-message"
				v-for="msg in showDetailsForError.messages"
				:key="msg"
				v-text="msg"
			/>
		</StandardModal>
	</div>
</template>

<script>
import { StandardModal } from '@/components/common'
import { CircleCheckIcon, CircleExclamationIcon } from '@/icons'

export default {
	name: 'BulkErrorModal',
	components: {
		StandardModal,
		CircleCheckIcon,
		CircleExclamationIcon,
	},
	props: {
		successCount: Number,
		errorCount: Number,
		errors: Array,
	},
	data() {
		return { showDetailsForError: null }
	},
	emits: ['confirm', 'cancel'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.results-section {
	padding: 12px 24px;
	border-bottom: 1px solid var(--neutral-200);
}

.results-banner {
	height: 40px;
	@include flex;
	padding: 0 8px;
	border-radius: 6px;
	background: rgba($text-gray-dark, 0.2);
	margin-bottom: 16px;
	font-size: 14px;
	&:last-child {
		margin-bottom: 0;
	}
	&.error {
		background: rgba($error-red, 0.2);
		> .pronto-icon {
			color: var(--red-200);
		}
	}
	&.success {
		background: rgba($pronto-green, 0.2);
		> .pronto-icon {
			color: var(--teal-300);
		}
	}
	> .pronto-icon {
		font-size: 18px;
		margin-right: 12px;
	}
	strong {
		font-family: Avenir-Heavy;
	}
}

.error-item {
	height: 44px;
	padding: 0 24px;
	align-items: center;
	@include flex-spread;
	.error-item-right {
		@include flex;
		> .pronto-icon {
			margin-right: 8px;
		}
		color: var(--red-200);
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
}
</style>

<style lang="scss" scoped>
@import 'src/sass/variables';

.error-details-modal {
	.modal-body {
		padding: 24px;
		@include flex-column-center;
		.pronto-icon-halo {
			color: var(--red-200);
			font-size: 55px;
			margin-bottom: 24px;
		}
		.error-details-message {
			margin-bottom: 16px;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}
</style>
